// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import Typography from '@mui/material/Typography'
import moment from 'moment'
import React, { Component } from 'react'
import { Mutation } from 'react-apollo'
import { i18n } from '../index'
import ChecklistButton from './ChecklistButton'
import EditChecklistQuestionsLink from './EditChecklistQuestionsLink'
import css from './ToiletCheckSection.css'
import { upsertDailyToiletCheck } from './checklistQueries'
const dateFormat = 'YYYY-MM-DD'
type ToiletTask = {
  time: number
  checked: boolean
}
type Props = {
  stationId: string
  openDialog: (...args: Array<any>) => any
  currentTime: moment
  statuses: Record<
    string,
    {
      hour: number
      status: boolean
      date: string
    }
  >
}
type State = {
  statuses: Record<
    string,
    {
      hour: number
      status: boolean
      date: string
    }
  >
}

const HourRow = (statuses) => Object.values(statuses).map(({ hour }: any, index) => <th key={index}>{hour}</th>)

const ChecklistButtonRow = function (statuses, currentHour, callback, check) {
  const today = moment().format(dateFormat)
  const yesterday = moment().subtract(1, 'days').format(dateFormat)
  const tomorrow = moment().add(1, 'days').format(dateFormat)

  // logic to lock a toilet check button
  const isLocked = (dateOfItem: string, currentTime: string, checkHour: number) => {
    let [hour, minute] = currentTime.split(':')
    hour = Number(hour)
    minute = Number(minute)

    // If hour to check is the first hour of tomorrow
    if (dateOfItem === tomorrow && checkHour === 0 && hour === 23 && minute >= 50) {
      return false
    } else if (dateOfItem === today) {
      if (checkHour === hour || (minute <= 10 && checkHour === hour - 1)) {
        return false
      }

      if (minute >= 50 && checkHour === hour + 1) {
        return false
      }
    } else if (dateOfItem === yesterday && 23 === checkHour && minute <= 10 && 0 === hour) {
      // make sure 23:00's check item yesterday can be checked until 00:10 today, e.g. 00:09
      return false
    }

    return true
  }

  return Object.values(statuses).map(({ hour, status, date }: any, index) => (
    <td key={index}>
      <ChecklistButton
        date={date}
        isChecked={status}
        isLocked={isLocked(date, currentHour, hour)}
        timePeriod={hour}
        callback={callback}
        check={check}
      />
    </td>
  ))
}

export default class ToiletCheckSection extends Component<Props, State> {
  state = {
    statuses: this.props.statuses,
  }
  check = async (date: string, hour: number, currentStatus: boolean, callback: (...args: Array<any>) => any) => {
    const { stationId, openDialog } = this.props

    try {
      await callback({
        variables: {
          stationId,
          hour,
          date,
          status: !currentStatus,
        },
      })
      const targetStatus = this.state.statuses[`_${hour}`]

      // 25% of opening the dialog when check the button
      if (!currentStatus && Math.random() < 0.25) {
        openDialog()
      }

      this.setState({
        statuses: {
          ...this.state.statuses,
          [`_${hour}`]: { ...targetStatus, status: !currentStatus },
        },
      })
    } catch (err) {
      // TODO: error handle (sometimes checking an item fails)
    }
  }

  render() {
    const { currentTime = moment(), questions = [], stationId } = this.props
    const { statuses } = this.state
    return (
      <Mutation mutation={upsertDailyToiletCheck}>
        {(upsertDailyToiletCheck, { data }) => (
          <div className={css.toiletCheckContainer}>
            <Typography variant='h5' className={css.sectionHeader}>
              {i18n.t('checkList.toiletCheckListHeader')}
            </Typography>
            <div className={css.toiletChecksContainer}>
              <table className={css.toiletTable}>
                <thead>
                  <tr>
                    <th className={css.timeHeader}>{i18n.t('checkList.time')}</th>
                    {HourRow(statuses)}
                  </tr>
                </thead>
                <tbody>
                  <tr className={css.row}>
                    <td>&nbsp;</td>
                    {ChecklistButtonRow(statuses, currentTime.format('HH:mm'), upsertDailyToiletCheck, this.check)}
                  </tr>
                </tbody>
              </table>
            </div>
            {questions.length > 0 && (
              <ul className={css.questionList}>
                {questions.map((q) => (
                  <li key={q.id}>{q.description}</li>
                ))}
              </ul>
            )}
            <EditChecklistQuestionsLink to={`/yllapito/toimipaikat/asetukset/${stationId}#tarkastuskysymykset`} />
          </div>
        )}
      </Mutation>
    )
  }
}
